// export const BaseIp = 'http://192.168.29.113:8000/'     //---local path (URL)
export const BaseIp = 'https://warana.digitaltkiet.in/'     //---online path (URL)

export const IMG_BASE_URL = BaseIp + 'uploads/'     //---local path (URL)

//=================================================================================================

export const AdminLoginAPI = BaseIp + "admin/adminLogin";  //ADMIN LOGIN API (POST)

export const InactiveRegList = BaseIp + "member/registrationPending";   //Get Pending Reg. Fee List (GET)

export const ApprovePendingRegFeeList = BaseIp + "registration/getAllPendingRegistration";   //Get Pending Reg. Fee List (GET)


export const AdminDashboard = BaseIp + "dashboard/dashboardDetails";   //Get Dashboard List (GET)

export const RegFeeApproveReject = BaseIp + "registration/adminApproveAndRejectRegistrationPayment";   // Reg. Fee Approve/Reject  (PUT) (params =>  reg_id)

export const ApprovedRegStudentList = BaseIp + "registration/getAllApprovalRegistration";       //Get Registered Student (Fee Approved) List (GET)

export const UpdateApprovedRegStudentData = BaseIp + "registration/updateRegistration";       //Update Registered Student Data (Update Approved Student Data) (PUT) (params=> reg_id)

